import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const Harmonicity = ({harmonicity}) => { 
    let whole = Math.floor(harmonicity);
    let decimal = harmonicity - whole;
    return (
        <div className="harmonicity fm-parameter">
          <div>
            Harmonicity
          </div>
          <div className="values">
            <div className="whole-value">
              {whole}
            </div>
            <div className="dot-value">
              .
            </div>
            <div className="decimal-value">
              {decimal}
            </div>
          </div>
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
      harmonicity: props.oscillator.harmonicityParameter.get()
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Harmonicity);
